import { isTextSelected, isSpecialKey, isNumericKey, MagicConfigMixin } from '@gig/magic-common';
import { __extends, __decorate } from 'tslib';
import { Component, Mixins } from 'vue-property-decorator';

/**
 * Component that renders an input field type number.
 */
var NumberComponent = /** @class */ (function (_super) {
    __extends(NumberComponent, _super);
    function NumberComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(NumberComponent.prototype, "pattern", {
        get: function () {
            var pattern = this.$attrs.pattern;
            if (pattern) {
                return pattern;
            }
            return '\\d*';
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Returns the new input value
     * Handle selected text
     * @param event
     */
    NumberComponent.prototype.getValue = function (event) {
        var target = this.getRealTarget(event);
        var currValue = target.value || '';
        // keyCode is deprecated; String.fromCharCode() returns odd results for NumPad keys
        // fallback to event.keyCode % 48 + 48 - this allows NumPad to be used on old browsers
        var value = event.key
            ? event.key
            : "" + currValue + String.fromCharCode((event.keyCode % 48) + 48);
        if (target.selectionStart !== target.selectionEnd) {
            var valueAsArray = currValue.split('');
            valueAsArray.splice(target.selectionStart, target.selectionEnd, value);
            return parseInt(valueAsArray.join(''), 10);
        }
        return parseInt(value, 10);
    };
    /**
     * Checks if value is within range
     * @param value
     */
    NumberComponent.prototype.isInRange = function (value) {
        if (this.$attrs.min && this.$attrs.max) {
            var min = parseInt(this.$attrs.min, 10);
            var max = parseInt(this.$attrs.max, 10);
            return value >= min && value <= max;
        }
        return true;
    };
    NumberComponent.prototype.onKeyDown = function (event) {
        // ignore all keydown events that are part of composition
        // @ts-ignore
        if (event.isComposing || event.keyCode === 229) {
            return;
        }
        var target = this.getRealTarget(event);
        var currValue = target.value || '';
        var maxLength = this.$attrs.maxlength
            ? parseInt(this.$attrs.maxlength, 10)
            : -1;
        var isFieldComplete = currValue.length === maxLength && !isTextSelected(currValue);
        var value = this.getValue(event);
        if (!isSpecialKey(event) &&
            (!isNumericKey(event) || !this.isInRange(value) || isFieldComplete)) {
            event.preventDefault();
        }
    };
    NumberComponent.prototype.getRealTarget = function (event) {
        if (!event.composedPath) {
            return event.target;
        }
        var path = event.composedPath();
        return path[0];
    };
    NumberComponent = __decorate([
        Component({
            name: 'ui-number',
            inheritAttrs: true,
        })
    ], NumberComponent);
    return NumberComponent;
}(Mixins(MagicConfigMixin)));

export default NumberComponent;
